














import Vue from 'vue'

export default Vue.extend({
  props: {
    href: {
      type: String,
      default: '',
      required: false,
    },
    to: {
      type: String,
      default: '',
      required: false,
    }
    // どちらも指定しない場合clickイベント
  },
  methods: {
    clickEvent(e: Event) {
      this.$emit('click', e)
    }
  }
})
